import { render, staticRenderFns } from "./SetupContractsStep.vue?vue&type=template&id=3f9b260a&scoped=true&"
import script from "./SetupContractsStep.vue?vue&type=script&lang=ts&"
export * from "./SetupContractsStep.vue?vue&type=script&lang=ts&"
import style0 from "./SetupContractsStep.vue?vue&type=style&index=0&id=3f9b260a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b260a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VCol,VDivider,VRow,VSelect})
